/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { VariantAssignmentResponseSwaggers } from 'src/core/services/azureExpSwaggers';

export const getAzureExpService = () => {
    const azureExperimentationBaseUrl =
        'https://default.exp-tas.com/exptas77/6b8773d6-f5cf-44a0-8989-680f12b28db6-langstudioexp/api/v1/tas';

    const getFlightsConfigs = async ({
        resourceId,
        resourceName,
        subscriptionId,
        resourceRegion,
        portalLocale,
        portalEnvironment
    }: {
        resourceId: string;
        resourceName: string;
        subscriptionId: string;
        resourceRegion: string;
        portalLocale: string;
        portalEnvironment: string;
    }): Promise<VariantAssignmentResponseSwaggers> => {
        const parameters = `resource_id=${resourceId}, resource_name=${resourceName}, subscription_id=${subscriptionId}, resource_region=${resourceRegion}, portal_locale=${portalLocale}, portal_environment=${portalEnvironment}`;

        const response = await fetch(azureExperimentationBaseUrl, {
            headers: {
                'x-exp-parameters': parameters,
                'x-exp-sdk-version': '3'
            }
        });

        return response.json();
    };

    return { getFlightsConfigs };
};
